import LeadsListPageContainer from './containers/LeadsListPageContainer'

export default LeadsListPageContainer
